module.exports = __webpack_public_path__ + "static/media/star-purple.97aa0c13.svg";